import { config } from 'env_def';
import moment from 'moment';
import { isObject, cloneDeep } from 'lodash';
import { localSearchDataFilterName, mailSearchAttachmentFilterName, mailTable, } from './mail_action_store_model';
import { MailContentHandler } from './mail_content_handler';
import { MailAbstractHandler } from './mail_abs_handler';
import { util } from '@/api/util';
import { customerSysConfig } from '@/config';
import corpMailUtils from './corp_mail_utils';
import { api } from '@/api/api';
import { getIn18Text } from '@/api/utils';
export class MailSearchHandler extends MailContentHandler {
    constructor() {
        super(...arguments);
        this.advancedSearchResultIds = [];
        this.advancedSearchFolder = [];
        this.advancedSearchFilterCond = [];
        this.fromAddressGroupKey = '';
        this.advacendSearchResultTotal = 0;
        this.advancedSearchResultCache_sd = [];
        this.statKeyMap = {
            'flags.read': {
                label: getIn18Text('YUEDUZHUANGTAI'),
                valueMapping: (key) => {
                    if (key === 'true') {
                        return {
                            valueLabel: getIn18Text('YIDU'),
                            cond: {
                                field: 'flags',
                                operator: '=',
                                operand: { read: true },
                            },
                        };
                    }
                    return {
                        valueLabel: getIn18Text('WEIDU'),
                        cond: {
                            field: 'flags',
                            operator: '=',
                            operand: { read: false },
                        },
                    };
                },
            },
            sentDate: {
                label: getIn18Text('SHIJIANFANWEI'),
                valueMapping: (key) => {
                    if (key) {
                        const dt = moment(key);
                        if (dt.isSameOrAfter(moment().clone().subtract(2, 'day'), 'day')) {
                            return {
                                valueLabel: getIn18Text('SANTIANNEI'),
                                cond: {
                                    field: 'sentDate',
                                    operator: 'in_range',
                                    operand: key + ':',
                                },
                            };
                        }
                        if (dt.isSameOrAfter(moment().clone().subtract(6, 'day'), 'day')) {
                            return {
                                valueLabel: getIn18Text('YIZHOUNEI'),
                                cond: {
                                    field: 'sentDate',
                                    operator: 'in_range',
                                    operand: key + ':',
                                },
                            };
                        }
                        if (dt.isSameOrAfter(moment().clone().subtract(29, 'day'), 'day')) {
                            return {
                                valueLabel: getIn18Text('YIYUENEI'),
                                cond: {
                                    field: 'sentDate',
                                    operator: 'in_range',
                                    operand: key + ':',
                                },
                            };
                        }
                        if (dt.isSameOrAfter(moment().clone().subtract(89, 'day'), 'day')) {
                            return {
                                valueLabel: getIn18Text('SANYUENEI'),
                                cond: {
                                    field: 'sentDate',
                                    operator: 'in_range',
                                    operand: key + ':',
                                },
                            };
                        }
                        if (dt.isBefore(moment().clone().subtract(89, 'day'), 'day')) {
                            return {
                                valueLabel: getIn18Text('SANYUEQIAN'),
                                cond: {
                                    field: 'sentDate',
                                    operator: 'in_range',
                                    operand: ':' + key,
                                },
                            };
                        }
                    }
                    return undefined;
                },
            },
            'flags.attached': {
                label: getIn18Text('YOUWUFUJIAN'),
                valueMapping: (key) => {
                    if (key === 'true') {
                        return {
                            valueLabel: getIn18Text('YOUFUJIAN'),
                            cond: {
                                field: 'flags',
                                operator: '=',
                                operand: { attached: true },
                            },
                        };
                    }
                    return {
                        valueLabel: getIn18Text('WUFUJIAN'),
                        cond: {
                            field: 'flags',
                            operator: '=',
                            operand: { attached: false },
                        },
                    };
                },
            },
            fromAddress: {
                label: getIn18Text('FAJIANREN'),
                valueMapping: (key) => {
                    const item = this.contactHandler.parseContactStr(key, '');
                    const parsedInfo = item.parsed[0];
                    return {
                        valueLabel: (parsedInfo && parsedInfo.name) || '',
                        cond: {
                            field: 'from',
                            operand: (parsedInfo && parsedInfo.email) || key,
                            operator: 'contains',
                            ignoreCase: true,
                        },
                    };
                },
            },
        };
    }
    async handleSearchGroupResult(groupings, _account) {
        var _a;
        const actions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (actions.mailBoxOriginData && actions.mailBoxOriginData.length > 0) {
            const mailBoxModels = this.handleFolderRet(actions.mailBoxOriginData, groupings);
            return Promise.resolve(mailBoxModels);
        }
        await this.doListMailBox(undefined, undefined, undefined, _account);
        if (actions.mailBoxOriginData && actions.mailBoxOriginData.length > 0) {
            return this.handleFolderRet(actions.mailBoxOriginData, groupings, _account);
        }
        return Promise.reject(new Error('文件夹请求失败，请稍后重试'));
    }
    handleSummaryEntities(ids, key, _account) {
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        const urlKey = isCorpMail ? 'getContentByIds' : 'searchMailInfo';
        const url = this.buildUrl(urlKey, undefined, undefined, _account);
        const data = {
            ids,
            pattern: key,
            summaryWindowSize: isCorpMail ? ids.length : null,
        };
        return this.impl
            .post(url, data, Object.assign(Object.assign({}, (this.getConfigForHttp(urlKey, { data, url, method: 'post' }) || {})), { _account }))
            .then(this.unpackData.bind(this))
            .then((res) => {
            var _a;
            const ret = {};
            if (res.code === MailAbstractHandler.sOk) {
                (_a = res.var) === null || _a === void 0 ? void 0 : _a.forEach(it => {
                    const mid = isCorpMail ? it.id : it.mid;
                    ret[mid] = it.summary;
                });
            }
            return ret;
        });
    }
    async handleSummaryEntities_sd(mails, key, subordinateId) {
        var _a, _b;
        if (mails && mails.length > 0) {
            const key1 = 'getColleagueSummaryInfos';
            const url = this.impl.buildUrl(this.systemApi.getUrl(key1), {
                colleagueAccId: subordinateId,
            });
            const idsMap = new Map();
            mails.forEach(m => {
                if (m.belongEmail) {
                    const map = idsMap.get(m.belongEmail);
                    if (map && map.length) {
                        map.push(m.id);
                    }
                    else {
                        idsMap.set(m.belongEmail, [m.id]);
                    }
                }
            });
            const list = [];
            for (const [key, value] of idsMap) {
                list.push({
                    subEmail: key,
                    mids: value,
                });
            }
            const data = {
                list,
                pattern: key,
            };
            const res = await this.impl.post(url, data, {
                url,
                data,
                cachePolicy: 'noCache',
                noEnqueue: true,
                contentType: 'json',
            });
            const result = res.data;
            const summaryInfos = ((_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.summaryInfos) || [];
            const ret = {};
            if ((result === null || result === void 0 ? void 0 : result.success) && Array.isArray(summaryInfos) && summaryInfos.length > 0) {
                summaryInfos.forEach(it => {
                    const mid = it.mid || it.id;
                    ret[mid] = it.summary;
                });
                return ret;
            }
            return ret;
        }
        console.error('handleSummaryEntities_sd: mails is empty');
        return Promise.resolve({});
    }
    async handleSummaryEntitiesMoreAccounts(mails, key) {
        var _a, _b;
        if (mails && mails.length > 0) {
            const key1 = 'getSummaryInfosMoreAccounts';
            const url = this.impl.buildUrl(this.systemApi.getUrl(key1), {});
            const idsMap = new Map();
            mails.forEach(m => {
                if (m.belongEmail) {
                    const map = idsMap.get(m.belongEmail);
                    if (map && map.length) {
                        map.push(m.id);
                    }
                    else {
                        idsMap.set(m.belongEmail, [m.id]);
                    }
                }
            });
            const list = [];
            for (const [key, value] of idsMap) {
                list.push({
                    subEmail: key,
                    mids: value,
                });
            }
            const data = {
                list,
                pattern: key,
            };
            const res = await this.impl.post(url, data, {
                url,
                data,
                cachePolicy: 'noCache',
                noEnqueue: true,
                contentType: 'json',
            });
            const result = res.data;
            const summaryInfos = ((_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.summaryInfos) || [];
            const ret = {};
            if ((result === null || result === void 0 ? void 0 : result.success) && Array.isArray(summaryInfos) && summaryInfos.length > 0) {
                summaryInfos.forEach(it => {
                    const mid = it.mid || it.id;
                    ret[mid] = it.summary;
                });
                return ret;
            }
            return ret;
        }
        console.error('handleSummaryEntitiesMoreAccounts: mails is empty');
        return Promise.resolve({});
    }
    replaceSearchContent(str, keyStr, encode) {
        if (!keyStr || !str) {
            return str;
        }
        const encodeKey = encode ? keyStr : this.htmlApi.encodeHtml(keyStr);
        let ret = '';
        let start = 0;
        let pre = 0;
        while (pre < str.length) {
            start = str.indexOf(encodeKey, pre);
            if (start >= 0) {
                let subStr = str.substring(pre, start);
                if (subStr.endsWith('<b>')) {
                    subStr = subStr.replace(/<\s*b\s*>/gi, '');
                }
                ret += subStr;
                ret += '<b>';
                ret += encode ? this.htmlApi.encodeHtml(encodeKey) : encodeKey;
                ret += '</b>';
                pre = start + encodeKey.length;
            }
            else {
                let content = str.substring(pre);
                if (content.startsWith('</b>')) {
                    content = content.replace(/<\s*\/b\s*>/gi, '');
                }
                ret += encode ? this.htmlApi.encodeHtml(content) : content;
                break;
            }
        }
        return ret;
    }
    buildSearchResult(result, searchId, key, total, fid, searchType = 'all', filterCond, _account, keyJson) {
        var _a, _b;
        const resultElement = result[0];
        const hasAttachmentSearch = searchType === 'all' || searchType === 'attachment';
        const titleKey = (keyJson === null || keyJson === void 0 ? void 0 : keyJson.title) || '';
        const anameKey = (keyJson === null || keyJson === void 0 ? void 0 : keyJson.aname) || '';
        const contentKey = (keyJson === null || keyJson === void 0 ? void 0 : keyJson.content) || '';
        if (resultElement && resultElement.length > 0) {
            const summaries = result[1];
            for (const it of resultElement) {
                let briefChanged = false;
                if (it && it.id && summaries[it.id]) {
                    const summary = summaries[it.id];
                    if (summary !== '......' && (contentKey || key)) {
                        const sm = summary.replace(/<\s*b\s*>/gi, '').replace(/<\s*\/b\s*>/gi, '');
                        it.entry.brief = this.replaceSearchContent(sm, contentKey || key, true);
                        briefChanged = true;
                    }
                }
                if (it.entry.brief && !briefChanged && searchType === 'all' && (contentKey || key)) {
                    it.entry.brief = this.replaceSearchContent(it.entry.brief, contentKey || key, false);
                }
                if (searchType !== 'all' && !contentKey) {
                    const regex = /<\/?b>/g;
                    it.entry.brief = (_a = it.entry.brief) === null || _a === void 0 ? void 0 : _a.replace(regex, '');
                }
                if (['all', 'title'].includes(searchType) && (titleKey || key)) {
                    it.entry.title = this.replaceSearchContent(it.entry.title, titleKey || key, false);
                }
                if (hasAttachmentSearch && it.entry.attachment && it.entry.attachment.length > 0 && (anameKey || key)) {
                    it.entry.attachment.forEach(it => {
                        it.fileHandledName = this.replaceSearchContent(it.fileName, anameKey || key, true);
                    });
                }
                if (['all', 'receiver'].includes(searchType) && Array.isArray(it.receiver) && it.receiver.length > 0 && key) {
                    it.receiver = it.receiver.map(v => (Object.assign(Object.assign({}, v), { contact: Object.assign(Object.assign({}, v.contact), { contact: Object.assign(Object.assign({}, v.contact.contact), { contactName: this.replaceSearchContent(v.contact.contact.contactName, key, true) }) }), contactItem: Object.assign(Object.assign({}, v.contactItem), { contactItemVal: this.replaceSearchContent(v.contactItem.contactItemVal, key, true) }) })));
                }
            }
        }
        const stats = cloneDeep(result[3]);
        if (stats && stats.fromAddress && stats.fromAddress.items) {
            const fromItems = stats.fromAddress.items;
            Object.keys(fromItems).forEach(k => {
                const contactLabel = util.getContactPYLabel(fromItems[k].label).charAt(0).toLocaleUpperCase();
                fromItems[k].contactLabel = fromItems[k].contactLabel || contactLabel || fromItems[k].filterCond.operand.toString().charAt(0).toLocaleUpperCase();
            });
        }
        const ret = {
            entities: resultElement,
            folders: result[2],
            stats,
            searchId,
            total,
            _account: (_b = this.systemApi.getCurrentUser(_account)) === null || _b === void 0 ? void 0 : _b.id,
            key,
            filterCond,
            fid,
        };
        return ret;
    }
    storeSearchWords(srId, key, _account) {
        var _a;
        const targetActions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (!(targetActions === null || targetActions === void 0 ? void 0 : targetActions.searchWord[key])) {
            targetActions.searchWord[key] = srId;
        }
        this.storeApi.put(MailAbstractHandler.mailSearchSeq, srId + '', { _account }).then();
        this.storeApi.put(MailAbstractHandler.mailSearchKeyWord, JSON.stringify(targetActions === null || targetActions === void 0 ? void 0 : targetActions.searchWord), { _account }).then();
    }
    storeSearchIds(srId, ids, reqKey, _account) {
        var _a;
        const targetActions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        const cache = (targetActions === null || targetActions === void 0 ? void 0 : targetActions.searchMidsCache) || {};
        if (!cache[srId]) {
            cache[srId] = {};
        }
        cache[srId][reqKey] = ids;
    }
    storeSearchFolderRes(re, reqKey, srId, _account) {
        var _a;
        const targetActions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (!targetActions)
            return;
        targetActions.searchResCache[srId] = targetActions.searchResCache[srId] || {};
        targetActions.searchResCache[srId][reqKey] = re;
    }
    storeSearchCache_sd(emailInfos, reqKey, _account) {
        var _a;
        const targetActions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        const cache = (targetActions === null || targetActions === void 0 ? void 0 : targetActions.searchResCache_sd) || {};
        cache[reqKey] = emailInfos;
    }
    storeSearchCacheMoreAccounts(emailInfos, reqKey, _account) {
        var _a;
        const targetActions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        const cache = (targetActions === null || targetActions === void 0 ? void 0 : targetActions.searchResCacheMoreAccounts) || {};
        cache[reqKey] = emailInfos;
    }
    async doAdvanceSearchMail(searchParamsModel, noCache = false, _account) {
        const fid = (searchParamsModel && searchParamsModel.fids && searchParamsModel.fids[0]) || undefined;
        console.log('4444----高级搜索---searchParamsModel', searchParamsModel);
        console.log('4444----高级搜索---noCache', noCache);
        if (searchParamsModel.start === 0) {
            this.advancedSearchResultIds = [];
            if (noCache) {
                this.advancedSearchFolder = [];
                this.advancedSearchFilterCond = [];
                this.cachedStats = undefined;
                this.fromAddressGroupKey = '';
            }
        }
        else if (this.advancedSearchResultIds.length > 0) {
            const ids = this.advancedSearchResultIds.slice(searchParamsModel.start, searchParamsModel.start + searchParamsModel.limit);
            if (ids.length > 0) {
                const promiseEntry = new Promise(re => {
                    this.doListMailBoxEntities({
                        mids: ids,
                        count: ids.length,
                        _account,
                    }).then(re);
                });
                const [res] = await Promise.all([promiseEntry]);
                const list = Array.isArray(res) ? res : res.data;
                this.loggerApi.track('mail_search_advance_page_success', {
                    searchParamsModel,
                    noCache,
                });
                return this.buildSearchResult([list, {}, this.advancedSearchFolder, this.cachedStats || {}], 0, searchParamsModel.pattern || '', this.advacendSearchResultTotal, fid, undefined, this.advancedSearchFilterCond);
            }
            return this.buildSearchResult([[], {}, this.advancedSearchFolder, this.cachedStats || {}], 0, '', this.advacendSearchResultTotal, fid, undefined, this.advancedSearchFilterCond);
        }
        else {
            return this.buildSearchResult([[], {}, this.advancedSearchFolder, this.cachedStats || {}], 0, '', this.advacendSearchResultTotal, fid, undefined, this.advancedSearchFilterCond);
        }
        const url = this.buildUrl('searchMail', undefined, undefined, _account);
        const formData = this.buildAdvancedSearchEntryReq(searchParamsModel);
        const searchRes = await this.impl.post(url, formData, this.getConfigForHttp('searchMail', {
            url,
            data: Object.assign({}, formData),
            method: 'post',
            _account,
        }));
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        if (isCorpMail) {
            corpMailUtils.corpMailTransformResponse(searchRes);
        }
        const searchResData = searchRes.data;
        if (searchResData.code === MailAbstractHandler.sOk) {
            const index = searchResData.var.findIndex(it => typeof it === 'string');
            let objRes;
            this.advacendSearchResultTotal = searchResData.var.length;
            if (index > -1) {
                objRes = searchResData.var.slice(0, index);
            }
            else {
                objRes = searchResData.var;
            }
            this.advancedSearchResultIds = searchResData.var.map(it => (typeof it === 'string' ? it : it.id));
            const promiseFolder = new Promise(re => {
                if (noCache) {
                    try {
                        this.handleSearchGroupResult(searchResData.groupings, _account).then(re);
                    }
                    catch (error) {
                        re([]);
                    }
                }
                else {
                    re(this.advancedSearchFolder);
                }
            });
            const promiseEntry = new Promise(re => {
                try {
                    this.handleListMailBoxEntities({
                        start: 0,
                        summaryWindowSize: searchParamsModel.summaryWindowSize || 20,
                    }, {
                        d: objRes,
                        t: objRes.length,
                    }, {
                        count: objRes.length,
                        _account,
                    }).then(re);
                }
                catch (error) {
                    re([]);
                }
            });
            const promiseStat = this.handleStatResult(searchResData.groupings);
            const [res1, res2, res3] = await Promise.all([promiseEntry, promiseFolder, promiseStat]);
            this.saveMails(res1, _account);
            this.advancedSearchFolder = res2;
            this.advancedSearchFilterCond = searchParamsModel.filterCond || [];
            this.cachedStats = res3;
            const groupKey = JSON.stringify({
                fids: searchParamsModel.fids,
                subject: searchParamsModel.subject,
                pattern: searchParamsModel.pattern,
            });
            if (groupKey === this.fromAddressGroupKey && groupKey !== '') {
                res3.fromAddress = this.cachedFromAddressGroup;
            }
            else {
                this.fromAddressGroupKey = groupKey;
                this.cachedFromAddressGroup = res3.fromAddress;
            }
            this.loggerApi.track('mail_search_advance_server_success', {
                searchParamsModel,
                noCache,
            });
            return this.buildSearchResult([res1, {}, res2, res3], -1, searchParamsModel.pattern || '', this.advacendSearchResultTotal, fid, undefined, searchParamsModel.filterCond, _account);
        }
        return this.buildSearchResult([[], {}, [], {}], 0, '', 0, fid, undefined, undefined, _account);
    }
    async doAdvanceSearchMail_sd(searchParamsModel, colleagueAccId, subEmails, _account) {
        var _a;
        const fid = (searchParamsModel && searchParamsModel.fids && searchParamsModel.fids[0]) || undefined;
        if (searchParamsModel.start === 0) {
            this.advancedSearchResultCache_sd = [];
        }
        else if (this.advancedSearchResultCache_sd.length > 0) {
            const result = this.advancedSearchResultCache_sd.slice(searchParamsModel.start, searchParamsModel.start + searchParamsModel.limit);
            if (result.length > 0) {
                const promiseEntry = this.handleListMailBoxEntities({
                    start: 0,
                    limit: 3000,
                    summaryWindowSize: searchParamsModel.summaryWindowSize || 20,
                }, {
                    d: result,
                    t: result.length,
                }, {
                    count: result.length,
                    _account,
                })
                    .then(result => (Array.isArray(result) ? result : result.data))
                    .then(result => result.map((m) => {
                    m.tpMailInfo = {
                        colleagueAccId,
                        belongEmail: m.owner,
                    };
                    m.isTpMail = true;
                    m.mailFrom = 'subordinate';
                    return m;
                }))
                    .catch(() => []);
                const list = await promiseEntry;
                return this.buildSearchResult([list, {}, [], {}], 0, searchParamsModel.pattern || '', this.advancedSearchResultCache_sd.length, fid);
            }
            return this.buildSearchResult([[], {}, [], {}], 0, '', this.advancedSearchResultCache_sd.length, fid);
        }
        else {
            return this.buildSearchResult([[], {}, [], {}], 0, '', this.advancedSearchResultCache_sd.length, fid);
        }
        const formData = this.buildAdvancedSearchEntryReq(searchParamsModel);
        formData.windowSize = 3000;
        formData.fid = formData.fids;
        const key1 = process.env.BUILD_ISEDM ? 'getColleagueSearchMessages' : 'getLxColleagueSearchMessages';
        const url = this.impl.buildUrl(this.systemApi.getUrl(key1), {
            colleagueAccId,
            subEmails,
        });
        const searchRes = await this.impl.post(url, formData, {
            url,
            data: formData,
            cachePolicy: 'noCache',
            noEnqueue: true,
            contentType: 'json',
        });
        const searchResData = searchRes.data;
        const emailInfosServer = ((_a = searchResData === null || searchResData === void 0 ? void 0 : searchResData.data) === null || _a === void 0 ? void 0 : _a.emailInfos) || [];
        const emailInfos = emailInfosServer.map((it) => {
            it.owner = it.belongEmail;
            return it;
        });
        if ((searchResData === null || searchResData === void 0 ? void 0 : searchResData.success) && Array.isArray(emailInfos) && emailInfos.length > 0) {
            this.advancedSearchResultCache_sd = emailInfos;
            const objRes = emailInfos.slice(searchParamsModel.start, searchParamsModel.start + searchParamsModel.limit);
            const promiseEntry = this.handleListMailBoxEntities({
                start: 0,
                limit: 3000,
                summaryWindowSize: searchParamsModel.summaryWindowSize || 20,
            }, {
                d: objRes,
                t: objRes.length,
            }, {
                count: objRes.length,
                _account,
            })
                .then(result => (Array.isArray(result) ? result : result.data))
                .then(result => result.map((m) => {
                m.tpMailInfo = {
                    colleagueAccId,
                    belongEmail: m.owner,
                };
                m.isTpMail = true;
                m.mailFrom = 'subordinate';
                return m;
            }))
                .catch(() => []);
            const res1 = await promiseEntry;
            return this.buildSearchResult([res1, {}, [], {}], -1, searchParamsModel.pattern || '', emailInfos.length, fid, undefined, undefined, _account);
        }
        return this.buildSearchResult([[], {}, [], {}], 0, '', 0, fid, undefined, undefined, _account);
    }
    async doAdvanceSearchMail_sd_more(searchParamsModel, _account) {
        var _a;
        const { subEmails2Account } = searchParamsModel;
        const data = this.buildAdvancedSearchEntryReq_more(searchParamsModel);
        const url = this.systemApi.getUrl('searchMailSdMore');
        const searchRes = await this.impl.post(url, data, {
            url,
            data,
            cachePolicy: 'noCache',
            noEnqueue: true,
            contentType: 'json',
        });
        const mid2Email = new Map();
        const mid2Owner = new Map();
        const summaryObj = {};
        const searchResData = searchRes.data;
        const emailInfosServer = ((_a = searchResData === null || searchResData === void 0 ? void 0 : searchResData.data) === null || _a === void 0 ? void 0 : _a.messageInfos) || [];
        const emailInfos = emailInfosServer.map((it) => {
            if (it.owner) {
                mid2Owner.set(it.id, this.contactHandler.parseContactStr(it.owner, ''));
            }
            it.owner = it.belongEmail;
            if (it.owners && it.owners.length) {
                mid2Email.set(it.id, it.owners.filter(Boolean).map(o => this.contactHandler.parseContactStr(o, '')));
            }
            if (it.summary) {
                summaryObj[it.id] = it.summary;
                delete it.summary;
            }
            if (it.attachments && it.attachments.length) {
                it.attachments = it.attachments.map(i => {
                    i.filename = i.fileName || i.i.filename || '附件名称未知';
                    return i;
                });
            }
            it.sentDate = moment(it === null || it === void 0 ? void 0 : it.sentTime).format('YYYY-MM-DD HH:mm:ss');
            return it;
        });
        if ((searchResData === null || searchResData === void 0 ? void 0 : searchResData.code) === 200 && Array.isArray(emailInfos) && emailInfos.length > 0) {
            const { hasMore, searchId, searchEmails } = searchResData.data;
            const searchIdRes = searchId || searchParamsModel.searchId;
            const searchEmailsRes = Array.isArray(searchEmails)
                ? searchEmails.map(emailStr => {
                    const contactItem = this.contactHandler.parseContactStr(emailStr, '');
                    return contactItem.parsed[0].email || '';
                })
                : [];
            const objRes = emailInfos;
            const promiseEntry = this.handleListMailBoxEntities({
                start: 0,
                limit: searchParamsModel.limit,
                summaryWindowSize: searchParamsModel.limit || 20,
            }, {
                d: objRes,
                t: objRes.length,
            }, {
                count: objRes.length,
                _account,
            })
                .then(result => (Array.isArray(result) ? result : result.data))
                .then(result => result.map((m) => {
                m.tpMailInfo = {
                    belongEmail: m.owner,
                    subordinateSearch: true,
                };
                m.isTpMail = true;
                m.mailFrom = 'subordinate';
                const ownerEmails = mid2Email.get(m.id);
                const ownerEmail = mid2Owner.get(m.id);
                m.tpMailInfo.receiverSD = ownerEmails || [];
                if (ownerEmail) {
                    const firstOwner = subEmails2Account[ownerEmail.parsed[0].email];
                    if (firstOwner) {
                        m.tpMailInfo.colleagueAccId = firstOwner;
                    }
                }
                return m;
            }))
                .catch(() => []);
            const res1 = await promiseEntry;
            const subjValues = Array.isArray(searchParamsModel.subjects) && searchParamsModel.subjects.filter(Boolean);
            const anameValues = Array.isArray(searchParamsModel.attachments) && searchParamsModel.attachments.filter(Boolean);
            const contentValues = Array.isArray(searchParamsModel.contents) && searchParamsModel.contents.filter(Boolean);
            const keyJson = subjValues || anameValues || contentValues
                ? { title: subjValues ? subjValues[0] : '', aname: anameValues ? anameValues[0] : '', content: contentValues ? contentValues[0] : '' }
                : undefined;
            const result = this.buildSearchResult([res1, summaryObj, [], {}], searchIdRes || -1, searchParamsModel.highlight || '', emailInfos.length, '', searchParamsModel.searchType || undefined, undefined, _account, keyJson);
            if (result.entities && result.entities.length) {
                result.entities = result.entities.map(mail => {
                    var _a;
                    if (((_a = mail.entry.brief) === null || _a === void 0 ? void 0 : _a.trim()) === '' || !mail.entry.brief) {
                        mail.entry.brief = summaryObj[mail.id] || '';
                    }
                    return mail;
                });
            }
            return Object.assign(Object.assign({}, result), { hasMore: !!hasMore, searchEmails: searchEmailsRes });
        }
        return Object.assign(Object.assign({}, this.buildSearchResult([[], {}, [], {}], 0, '', 0, '', undefined, undefined, _account)), { hasMore: false, code: searchResData === null || searchResData === void 0 ? void 0 : searchResData.code });
    }
    async getMailListFromSdAI(param) {
        var _a, _b;
        const { searchUrl, searchId } = param || {};
        const httpApi = api.getDataTransApi();
        const url = decodeURIComponent(searchUrl);
        const searchRes = await httpApi.get(url, { searchId });
        const mid2Email = new Map();
        const mid2Owner = new Map();
        const mid2OwnerId = new Map();
        const summaryObj = {};
        console.log('4444getMailListFromSdAI,下属同步邮件列表接口返回', searchRes);
        const searchResData = searchRes.data || [];
        const emailInfosServer = ((_b = (_a = searchResData === null || searchResData === void 0 ? void 0 : searchResData.result) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.mailList) || [];
        const emailInfos = emailInfosServer.map((it) => {
            if (it.owner) {
                mid2Owner.set(it.id, this.contactHandler.parseContactStr(it.owner, ''));
            }
            if (it.ownerId) {
                mid2OwnerId.set(it.id, it.ownerId);
            }
            it.owner = it.belongEmail;
            if (it.owners && it.owners.length) {
                mid2Email.set(it.id, it.owners.filter(Boolean).map(o => this.contactHandler.parseContactStr(o, '')));
            }
            if (it.summary) {
                summaryObj[it.id] = it.summary;
                delete it.summary;
            }
            if (it.attachments && it.attachments.length) {
                it.attachments = it.attachments.map(i => {
                    i.filename = i.fileName || i.i.filename || '附件名称未知';
                    return i;
                });
            }
            it.sentDate = moment(it === null || it === void 0 ? void 0 : it.sentTime).format('YYYY-MM-DD HH:mm:ss');
            return it;
        });
        if ((searchResData === null || searchResData === void 0 ? void 0 : searchResData.code) === 200 && Array.isArray(emailInfos) && emailInfos.length > 0) {
            const objRes = emailInfos;
            const promiseEntry = this.handleListMailBoxEntities({
                start: 0,
                limit: 3000,
                summaryWindowSize: 3000,
            }, {
                d: objRes,
                t: objRes.length,
            }, {
                count: objRes.length,
                _account: '',
            })
                .then(result => (Array.isArray(result) ? result : result.data))
                .then(result => result.map((m) => {
                m.tpMailInfo = {
                    belongEmail: m.owner,
                    subordinateSearch: true,
                    subordinateFromAI: true,
                };
                m.isTpMail = true;
                m.mailFrom = 'subordinate';
                const ownerEmails = mid2Email.get(m.id);
                const colleagueAccId = mid2OwnerId.get(m.id) || '';
                m.tpMailInfo.colleagueAccId = colleagueAccId;
                m.tpMailInfo.receiverSD = ownerEmails || [];
                m.entry.brief = summaryObj[m.id] || '';
                return m;
            }))
                .catch(() => []);
            const res1 = await promiseEntry;
            return res1;
        }
        return [];
    }
    async batchDeleteAdvnceSearch(params) {
        const { searchModel: searchParamsModel, mailSearchAccount: _account } = params;
        const url = this.buildUrl('searchMail', undefined, undefined, _account);
        const formData = this.buildAdvancedSearchEntryReq(searchParamsModel);
        const searchRes = await this.impl.post(url, formData, this.getConfigForHttp('searchMail', {
            url,
            data: Object.assign({}, formData),
            method: 'post',
            _account,
        }));
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        if (isCorpMail) {
            corpMailUtils.corpMailTransformResponse(searchRes);
        }
        const searchResData = searchRes.data;
        if (searchResData.code === MailAbstractHandler.sOk) {
            const advancedSearchResultIds = searchResData.var.map(it => (typeof it === 'string' ? it : it.id));
            if (advancedSearchResultIds && advancedSearchResultIds.length > 0) {
                return advancedSearchResultIds;
            }
        }
        return [];
    }
    buildAdvancedSearchEntryReq(searchParamsModel) {
        var _a;
        const condition = searchParamsModel.conditions[0];
        const conditions = [];
        const contentConditions = [];
        let flagConditions = [];
        if (searchParamsModel.pattern) {
            contentConditions.push({
                field: 'cont',
                operand: searchParamsModel.pattern,
                operator: 'contains',
            });
        }
        const readFlagsConditions = [];
        let customOperator = 'and';
        Object.keys(condition).forEach(field => {
            var _a, _b, _c;
            switch (field) {
                case 'flags':
                    if (((_a = condition.flags) === null || _a === void 0 ? void 0 : _a.attached) !== undefined) {
                        flagConditions = flagConditions.concat([
                            {
                                field: 'flags',
                                operand: {
                                    attached: condition.flags.attached,
                                },
                            },
                            {
                                field: 'flags',
                                operand: {
                                    linkAttached: condition.flags.attached,
                                },
                            },
                        ]);
                    }
                    if (((_b = condition.flags) === null || _b === void 0 ? void 0 : _b.read) !== undefined) {
                        readFlagsConditions.push({
                            field: 'flags',
                            operand: {
                                read: condition.flags.read,
                            },
                        });
                    }
                    break;
                case 'from':
                    if (condition.from) {
                        contentConditions.push({
                            field: 'from',
                            operand: condition.from,
                            operator: 'contains',
                            ignoreCase: true,
                        });
                    }
                    break;
                case 'to':
                    if (condition.to) {
                        contentConditions.push({
                            field: 'to',
                            operand: condition.to,
                            operator: 'contains',
                            ignoreCase: true,
                        });
                    }
                    break;
                case 'memo':
                    if (condition.memo) {
                        contentConditions.push({
                            field: 'memo',
                            operand: condition.memo,
                            operator: 'contains',
                            ignoreCase: true,
                        });
                    }
                    break;
                case 'subject':
                    if (condition.subject) {
                        contentConditions.push({
                            field: 'subject',
                            operand: condition.subject,
                            operator: 'contains',
                            ignoreCase: true,
                        });
                    }
                    break;
                case 'label0':
                    if (condition.label0 !== undefined || ((_c = searchParamsModel.fids) === null || _c === void 0 ? void 0 : _c.includes(-1))) {
                        conditions.push({
                            field: 'label0',
                            operator: '=',
                            operand: 1,
                        });
                    }
                    break;
                case 'operator':
                    customOperator = condition.operator || customOperator;
                    break;
                case 'sentDate':
                    if (condition.sentDate) {
                        const [start, end] = condition.sentDate;
                        let operator;
                        let operand;
                        if (start && end) {
                            operator = 'in_range';
                            operand = !Array.isArray(condition.sentDate) ? [condition.sentDate].join(':') : condition.sentDate.join(':');
                        }
                        else if (start) {
                            operator = '>=';
                            operand = start;
                        }
                        else if (end) {
                            operator = '<=';
                            operand = end;
                        }
                        if (start || end) {
                            conditions.push({
                                field: 'sentDate',
                                operand,
                                operator,
                            });
                        }
                    }
                    break;
                default:
                    break;
            }
        });
        if (contentConditions.length > 0) {
            conditions.push({
                conditions: contentConditions,
                operator: customOperator,
            });
        }
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        if (flagConditions.length > 0) {
            conditions.push({
                conditions: flagConditions,
                operator: isCorpMail ? 'or' : customOperator,
            });
        }
        if (readFlagsConditions.length > 0) {
            conditions.push({
                conditions: readFlagsConditions,
                operator: customOperator,
            });
        }
        const fids = (_a = searchParamsModel.fids) === null || _a === void 0 ? void 0 : _a.filter(id => id >= 0);
        const { tag } = searchParamsModel;
        return {
            conditions,
            order: searchParamsModel.order || 'date',
            desc: searchParamsModel.desc,
            windowSize: searchParamsModel.windowSize || 20,
            summaryWindowSize: searchParamsModel.summaryWindowSize || 20,
            returnAttachments: true,
            returnTag: true,
            fids: isCorpMail ? null : fids,
            fid: isCorpMail ? fids : null,
            tag: tag && (tag === null || tag === void 0 ? void 0 : tag.length) > 0 ? tag : null,
            groupings: (searchParamsModel === null || searchParamsModel === void 0 ? void 0 : searchParamsModel.ignoreGroup)
                ? undefined
                : {
                    fid: '',
                    fromAddress: '',
                },
        };
    }
    buildAdvancedSearchEntryReq_more(searchParamsModel) {
        const conditionsCommon = [];
        const keys = ['from', 'to', 'subj', 'cont', 'aname'];
        keys.forEach(key => {
            if (searchParamsModel[key]) {
                conditionsCommon.push(searchParamsModel[key]);
            }
        });
        const values = {
            searchId: searchParamsModel.searchId || '',
            colleagues: searchParamsModel.subEmails || [],
            conditions: [
                {
                    conditions: conditionsCommon,
                    operator: searchParamsModel.operator,
                },
            ],
            operator: 'and',
            limit: searchParamsModel.limit,
            highlight: searchParamsModel.highlight,
        };
        if (searchParamsModel.lastOrderTime) {
            values.lastOrderTime = +new Date(searchParamsModel.lastOrderTime);
        }
        if (searchParamsModel.start || searchParamsModel.end) {
            const { start } = searchParamsModel;
            const { end } = searchParamsModel;
            let operator;
            let operand;
            if (start && end) {
                operator = 'in_range';
                operand = `${start}:${end}`;
            }
            else if (start) {
                operator = '>=';
                operand = start;
            }
            else if (end) {
                operator = '<=';
                operand = end;
            }
            values.conditions.push({ field: 'sentDate', operand, operator });
        }
        if (searchParamsModel.attach) {
            const hasAttach = searchParamsModel.attach === 1;
            values.conditions.push({
                conditions: [
                    {
                        field: 'flags',
                        operand: { attached: hasAttach },
                    },
                    {
                        field: 'flags',
                        operand: { linkAttached: hasAttach },
                    },
                ],
                operator: 'or',
            });
        }
        return values;
    }
    getSearchDataCondition(data, key, mailSearchType) {
        var _a;
        const isSearchAll = !mailSearchType || mailSearchType === 'all';
        const isSearchTitle = mailSearchType === 'title';
        const titleCondition = isSearchAll || isSearchTitle ? (_a = data.title) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(key) : false;
        if (isSearchTitle) {
            return titleCondition;
        }
        const isSearchSender = mailSearchType === 'sender';
        const fromEmailCondition = isSearchAll || isSearchSender ? !!data.fromEmail && data.fromEmail.toLowerCase().includes(key) : false;
        const fromNameCondition = isSearchAll || isSearchSender ? !!data.fromName && data.fromName.toLowerCase().includes(key) : false;
        if (isSearchSender) {
            return fromEmailCondition || fromNameCondition;
        }
        const isSearchReceiver = mailSearchType === 'receiver';
        const toContactNameCondition = isSearchAll || isSearchReceiver ? util.testArrayContainsKey(key, data.toContactName) : false;
        const toEmailCondition = isSearchAll || isSearchReceiver ? util.testArrayContainsKey(key, data.toEmail) : false;
        if (isSearchReceiver) {
            return toContactNameCondition || toEmailCondition;
        }
        const briefCondition = !!data.brief && data.brief.toLowerCase().includes(key);
        return titleCondition || briefCondition || toContactNameCondition || fromEmailCondition || fromNameCondition || toEmailCondition;
    }
    getSearchDataFilter(data, additionalData) {
        const filterCond = additionalData === null || additionalData === void 0 ? void 0 : additionalData.param.filterCond;
        if (!filterCond || filterCond.length === 0) {
            return true;
        }
        const fromFilterCond = filterCond.find(f => f && f.field === 'from');
        const sentDateFilterCond = filterCond.find(f => f && f.field === 'sentDate');
        const attachedFilterCond = filterCond.find(f => f && f.field === 'flags' && f.operand && f.operand.attached !== undefined);
        if (fromFilterCond && fromFilterCond.operand) {
            if (!fromFilterCond.operand.includes(data.fromEmail)) {
                return false;
            }
        }
        if (sentDateFilterCond && sentDateFilterCond.operand) {
            let temp;
            const now = moment();
            const threeDayKey = now.clone().subtract(2, 'day').format('YYYY-MM-DD');
            const oneWeekKey = now.clone().subtract(6, 'day').format('YYYY-MM-DD');
            const oneMonthKey = now.clone().subtract(29, 'day').format('YYYY-MM-DD');
            const threeMonthKey = now.clone().subtract(89, 'day').format('YYYY-MM-DD');
            const threeMonthOutKey = now.clone().subtract(90, 'day').format('YYYY-MM-DD');
            if (sentDateFilterCond.operand.includes(threeDayKey)) {
                temp = moment(-data.sdTime).isSameOrAfter(moment(threeDayKey), 'day');
            }
            else if (sentDateFilterCond.operand.includes(oneWeekKey)) {
                temp = moment(-data.sdTime).isSameOrAfter(moment(oneWeekKey), 'day');
            }
            else if (sentDateFilterCond.operand.includes(oneMonthKey)) {
                temp = moment(-data.sdTime).isSameOrAfter(moment(oneMonthKey), 'day');
            }
            else if (sentDateFilterCond.operand.includes(threeMonthKey)) {
                temp = moment(-data.sdTime).isSameOrAfter(moment(threeMonthKey), 'day');
            }
            else if (sentDateFilterCond.operand.includes(threeMonthOutKey)) {
                temp = moment(-data.sdTime).isBefore(moment(threeMonthKey), 'day');
            }
            if (!temp) {
                return false;
            }
        }
        if (attachedFilterCond) {
            const hasAttachment = !(+data.attachmentCount === 0 || (+data.attachmentCount === 1 && data.isIcs));
            const temp = attachedFilterCond.operand.attached ? hasAttachment : !hasAttachment;
            if (!temp) {
                return false;
            }
        }
        return true;
    }
    async doLocalSearchMail(key, param) {
        console.time('4444----本地耗时');
        console.log('4444----本地---key', key);
        console.log('4444----本地---param', param);
        const isThread = param.checkType === 'checkThread' ? 1 : 0;
        const onlySearchAttachmemnt = param.searchType === 'attachment';
        const searchType = param.searchType || 'all';
        const filterData = onlySearchAttachmemnt
            ? Promise.resolve(undefined)
            : this.db.getByEqCondition(Object.assign({ filter: localSearchDataFilterName, additionalData: {
                    key,
                    param,
                    isThread,
                    searchType,
                } }, mailTable.data), param._account);
        const shouldSearchAttachment = param.searchType === 'all' || onlySearchAttachmemnt;
        const mailAttachmentCheck = shouldSearchAttachment
            ? this.db.getByEqCondition(Object.assign({ filter: mailSearchAttachmentFilterName, additionalData: {
                    key,
                    param,
                    isThread,
                    searchType,
                } }, mailTable.attachment), param._account)
            : Promise.resolve(undefined);
        try {
            console.time('4444----本地111');
            const { hasCache, mids: midsCache, checkMids: checkMidsCache, cacheKey } = this.doGetLocalSearchCacheIds(key, param);
            let mids = new Set();
            let checkMids = new Set();
            if (hasCache) {
                mids = midsCache;
                checkMids = checkMidsCache;
            }
            else {
                const [mailData, mailAttachment] = await Promise.all([filterData, mailAttachmentCheck]);
                this.buildSetData(mids, checkMids, undefined, mailAttachment);
                if (mailData && mailData.length) {
                    this.buildSetData(mids, checkMids, undefined, mailData);
                }
                this.storeLocalSearchIds(mids, checkMids, cacheKey, param._account);
            }
            console.timeEnd('4444----本地111');
            console.log('4444----本地---param', mids, checkMids);
            const mailDataArr = mids.size ? await this.db.getByIds(mailTable.data, Array.from(mids), param._account) : [];
            console.time('4444----本地222');
            const allStatusEntries = (await this.db.getByIds(mailTable.status, Array.from(mids), param._account)).filter(v => !!v);
            const allAttachmentEntries = mailDataArr && mailDataArr.length ? (await this.db.getByIds(mailTable.attachment, Array.from(mids), param._account)).filter(v => !!v) : mailAttachment || [];
            console.timeEnd('4444----本地222');
            const map = new Map();
            const attachmentMap = new Map();
            allStatusEntries.forEach(it => map.set(it.mid, it));
            allAttachmentEntries.forEach(it => attachmentMap.set(it.mid, it));
            if ((!param.filterCond || param.filterCond.length === 0) && !param.id) {
            }
            let total = mids.size;
            const filterMailData = this.getFilterMailData(mailDataArr, map, attachmentMap, param.id, param.filterCond || [], param.status);
            let entries = [];
            let groupings = {};
            let folder = [];
            let stat = {};
            if (total > 0) {
                total = filterMailData.length;
                const ids = filterMailData.map(m => m.mid);
                ids.sort((a, b) => {
                    const aData = map.get(a);
                    const bData = map.get(b);
                    if (!aData) {
                        return 1;
                    }
                    if (!bData) {
                        return -1;
                    }
                    return aData.rcTime - bData.rcTime;
                });
                const starter = param.index || 0;
                const needCheckId = starter + param.count > checkMids.size ? ids.slice(param.index) : ids.slice(starter, starter + param.count);
                entries = await this.mailDbHanlder.getMailById({
                    id: needCheckId,
                    noContent: true,
                    _account: param._account,
                });
                console.time('4444----本地333');
                groupings = this.buildGroupingsByFilter(mailDataArr, map, attachmentMap, param);
                console.timeEnd('4444----本地333');
                console.log('4444----本地---groupings', groupings);
                folder = await this.handleSearchGroupResult(groupings, param._account);
                console.log('4444----本地---folder', folder);
                stat = await this.handleStatResult(groupings);
                console.log('4444----本地---stat', stat);
            }
            const aaa = this.buildSearchResult([entries, {}, folder, stat], -1, key, total, param.id, param.searchType, param.filterCond, param._account);
            console.timeEnd('4444----本地耗时');
            console.log('4444----本地---aaa', aaa);
            this.loggerApi.track('mail_search_local_success', aaa);
            return aaa;
        }
        catch (error) {
            console.log('[mail-search] local Search error:', error);
            console.log('4444----本地---失败', error);
            this.loggerApi.track('mail_search_local_fail', { error, key, param });
            return this.buildSearchResult([[], {}, [], {}], -1, key, 0, param.id, param.searchType, param.filterCond, param._account);
        }
    }
    async doLocalSearchMailIds(key, param) {
        try {
            const res = await this.doLocalSearchMail(key, Object.assign(Object.assign({}, param), { count: 1000 }));
            if (res && (res === null || res === void 0 ? void 0 : res.entities.length) > 0) {
                return res.entities.map(item => item.id);
            }
        }
        catch (error) {
            console.log('[mail-search] local Search error:', error);
        }
        return Promise.resolve([]);
    }
    getFilterMailData(entriesIn, statusMap, attachmentMap, id, filterCondIn, status) {
        if (!id && filterCondIn.length === 0 && !status) {
            return entriesIn;
        }
        const filterCond = filterCondIn;
        const fromFilterCond = filterCond.find(f => f && f.field === 'from');
        const sentDateFilterCond = filterCond.find(f => f && f.field === 'sentDate');
        const attachedFilterCond = filterCond.find(f => f && f.field === 'flags' && f.operand && f.operand.attached !== undefined);
        const readFilterCond = filterCond.find(f => f && f.field === 'flags' && f.operand && f.operand.read !== undefined);
        const result = entriesIn.filter(mail => {
            var _a, _b, _c, _d, _e;
            if (fromFilterCond && fromFilterCond.operand) {
                if (!fromFilterCond.operand.includes(mail.fromEmail)) {
                    return false;
                }
            }
            if (sentDateFilterCond && sentDateFilterCond.operand) {
                let temp;
                const now = moment();
                const sendTime = Math.abs(mail.sdTime);
                const threeDayKey = now.clone().subtract(2, 'day').format('YYYY-MM-DD');
                const oneWeekKey = now.clone().subtract(6, 'day').format('YYYY-MM-DD');
                const oneMonthKey = now.clone().subtract(29, 'day').format('YYYY-MM-DD');
                const threeMonthKey = now.clone().subtract(89, 'day').format('YYYY-MM-DD');
                const threeMonthOutKey = now.clone().subtract(90, 'day').format('YYYY-MM-DD');
                if (sentDateFilterCond.operand.includes(threeDayKey)) {
                    temp = moment(sendTime).isSameOrAfter(moment(threeDayKey), 'day');
                }
                else if (sentDateFilterCond.operand.includes(oneWeekKey)) {
                    temp = moment(sendTime).isSameOrAfter(moment(oneWeekKey), 'day');
                }
                else if (sentDateFilterCond.operand.includes(oneMonthKey)) {
                    temp = moment(sendTime).isSameOrAfter(moment(oneMonthKey), 'day');
                }
                else if (sentDateFilterCond.operand.includes(threeMonthKey)) {
                    temp = moment(sendTime).isSameOrAfter(moment(threeMonthKey), 'day');
                }
                else if (sentDateFilterCond.operand.includes(threeMonthOutKey)) {
                    temp = moment(sendTime).isBefore(moment(threeMonthKey), 'day');
                }
                if (!temp) {
                    return false;
                }
            }
            if (attachedFilterCond) {
                const attachmentsArr = (_a = attachmentMap.get(mail.mid)) === null || _a === void 0 ? void 0 : _a.attachment;
                const attachmentNull = +mail.attachmentCount === 0 && (!attachmentsArr || attachmentsArr.length === 0);
                const onlyIcs = +mail.attachmentCount === 1 && mail.isIcs;
                const allInline = !attachmentsArr || attachmentsArr.length === 0 || attachmentsArr.every((m) => !!m.inlined);
                const hasAttachment = mail.linkAttached || (!attachmentNull && !onlyIcs && !allInline);
                const temp = attachedFilterCond.operand.attached ? hasAttachment : !hasAttachment;
                if (!temp) {
                    return false;
                }
            }
            if (id) {
                const folder = (_b = statusMap.get(mail.mid)) === null || _b === void 0 ? void 0 : _b.folder;
                const temp = folder === +id;
                if (!temp) {
                    return false;
                }
            }
            if (readFilterCond) {
                const hasRead = ((_c = statusMap.get(mail.mid)) === null || _c === void 0 ? void 0 : _c.readStatus) !== 0;
                const temp = readFilterCond.operand.read ? hasRead : !hasRead;
                if (!temp) {
                    return false;
                }
            }
            if (status === 'redFlag') {
                const isRedFlag = ((_d = statusMap.get(mail.mid)) === null || _d === void 0 ? void 0 : _d.redFlag) === 1;
                if (!isRedFlag) {
                    return false;
                }
            }
            if (status === 'unread') {
                const unRead = ((_e = statusMap.get(mail.mid)) === null || _e === void 0 ? void 0 : _e.readStatus) === 0;
                if (!unRead) {
                    return false;
                }
            }
            return true;
        });
        return result;
    }
    buildGroupingsByFilter(entries, statusMap, attachmentMap, param) {
        const re = {
            fid: [],
            'flags.read': [],
            'flags.attached': [],
            fromAddress: [],
            sentDate: [],
        };
        const { id, filterCond = [], status } = param;
        const filterCondIn = filterCond;
        if (entries && entries.length > 0) {
            const idEntries = this.getFilterMailData(entries, statusMap, attachmentMap, undefined, filterCondIn, status);
            const idGroupings = this.buildGroupingsByKey(idEntries, statusMap);
            re.fid = idGroupings.fid;
            const noFromFilterCondIn = filterCondIn.filter(f => f && f.field !== 'from');
            const fromEntries = this.getFilterMailData(entries, statusMap, attachmentMap, id, noFromFilterCondIn, status);
            const fromGroupings = this.buildGroupingsByKey(fromEntries, statusMap);
            re.fromAddress = fromGroupings.fromAddress;
            const noSentDateFilterCondIn = filterCondIn.filter(f => f && f.field !== 'sentDate');
            const sentDateEntries = this.getFilterMailData(entries, statusMap, attachmentMap, id, noSentDateFilterCondIn, status);
            const sentDateGroupings = this.buildGroupingsByKey(sentDateEntries, statusMap);
            re.sentDate = sentDateGroupings.sentDate;
            const noAttachmentFilterCondIn = filterCondIn.filter(f => {
                const isAttachment = f && f.field === 'flags' && f.operand && f.operand.attached !== undefined;
                return !isAttachment;
            });
            const attachmentEntries = this.getFilterMailData(entries, statusMap, attachmentMap, id, noAttachmentFilterCondIn, status);
            const attachmentGroupings = this.buildGroupingsByKey(attachmentEntries, statusMap, attachmentMap);
            re['flags.attached'] = attachmentGroupings['flags.attached'];
            const noReadFilterCondIn = filterCondIn.filter(f => {
                const isRead = f && f.field === 'flags' && f.operand && f.operand.read !== undefined;
                return !isRead;
            });
            const readEntries = this.getFilterMailData(entries, statusMap, attachmentMap, id, noReadFilterCondIn, status);
            const readGroupings = this.buildGroupingsByKey(readEntries, statusMap);
            re['flags.read'] = readGroupings['flags.read'];
        }
        return re;
    }
    buildGroupingsByKey(entries, statusMap, attachmentMap) {
        var _a, _b, _c, _d;
        const re = {
            fid: [],
            'flags.read': [],
            'flags.attached': [],
            fromAddress: [],
            sentDate: [],
        };
        if (entries && entries.length > 0) {
            const map = new Map();
            let unread = 0;
            let attached = 0;
            const fromAddrMap = new Map();
            const fromAddrNameMap = new Map();
            const fromAddrContactLabelMap = new Map();
            const nowTime = new Date().getTime();
            const sendDateMap = {
                [nowTime - 2 * 24 * 3600 * 1000]: 0,
                [nowTime - 6 * 24 * 3600 * 1000]: 0,
                [nowTime - 29 * 24 * 3600 * 1000]: 0,
                [nowTime - 89 * 24 * 3600 * 1000]: 0,
            };
            entries.forEach(it => {
                var _a, _b, _c;
                const folder = (_a = statusMap.get(it.mid)) === null || _a === void 0 ? void 0 : _a.folder;
                const num = map.get(folder) || 0;
                map.set(folder, num + 1);
                const contactName = it.fromEmail;
                const nickName = it.fromName;
                const contactLabel = util.getContactPYLabel(nickName).charAt(0).toLocaleUpperCase();
                const adNum = +fromAddrMap.get(contactName) || 0;
                fromAddrMap.set(contactName, adNum + 1);
                fromAddrNameMap.set(contactName, nickName);
                fromAddrContactLabelMap.set(contactName, contactLabel);
                const readStatus = ((_b = statusMap.get(it.mid)) === null || _b === void 0 ? void 0 : _b.readStatus) === 0 ? 'unread' : 'read';
                if (readStatus === 'unread') {
                    unread += 1;
                }
                const attachmentsArr = attachmentMap && ((_c = attachmentMap.get(it.mid)) === null || _c === void 0 ? void 0 : _c.attachment);
                const attachmentNull = +it.attachmentCount === 0 && (!attachmentsArr || attachmentsArr.length === 0);
                const onlyIcs = +it.attachmentCount === 1 && it.isIcs;
                const allInline = !attachmentsArr || attachmentsArr.length === 0 || attachmentsArr.every((m) => !!m.inlined);
                const hasAttachment = it.linkAttached || (!attachmentNull && !onlyIcs && !allInline);
                if (hasAttachment) {
                    attached += 1;
                }
                const sendTime = moment(Math.abs(it.sdTime));
                Object.keys(sendDateMap).forEach(time => {
                    if (moment.isMoment(sendTime) && sendTime.isSameOrAfter(moment(+time), 'day')) {
                        sendDateMap[+time] = sendDateMap[+time] + 1;
                    }
                });
            });
            (_a = re['flags.read']) === null || _a === void 0 ? void 0 : _a.push({ val: true, cnt: entries.length - unread });
            (_b = re['flags.read']) === null || _b === void 0 ? void 0 : _b.push({ val: false, cnt: unread });
            (_c = re['flags.attached']) === null || _c === void 0 ? void 0 : _c.push({ val: true, cnt: attached });
            (_d = re['flags.attached']) === null || _d === void 0 ? void 0 : _d.push({
                val: false,
                cnt: entries.length - attached,
            });
            map.forEach((k, v) => {
                var _a;
                (_a = re.fid) === null || _a === void 0 ? void 0 : _a.push({ val: v, cnt: k });
            });
            fromAddrMap.forEach((k, v) => {
                var _a;
                const nickName = fromAddrNameMap.get(v);
                const contactLabel = fromAddrContactLabelMap.get(v);
                (_a = re.fromAddress) === null || _a === void 0 ? void 0 : _a.push({
                    val: v,
                    cnt: k,
                    nickName,
                    contactLabel,
                });
            });
            const sendDateArr = [];
            Object.keys(sendDateMap)
                .sort((a, b) => +b - +a)
                .forEach(time => {
                sendDateArr.push({
                    val: moment(+time).format('YYYY-MM-DD'),
                    cnt: sendDateMap[+time],
                });
            });
            sendDateArr.push({
                val: moment().subtract(90, 'day').format('YYYY-MM-DD'),
                cnt: entries.length - sendDateMap[nowTime - 89 * 24 * 3600 * 1000],
            });
            re.sentDate = sendDateArr;
        }
        return re;
    }
    buildSetData(mids, checkMids, filterMids, mailData) {
        if (!mailData || mailData.length === 0) {
            return;
        }
        mailData.forEach(it => {
            mids.add(it.mid);
            if (!filterMids || filterMids.has(it.mid)) {
                checkMids.add(it.mid);
            }
        });
    }
    doGetSearchCacheInfo(key, param, searchId, noData, _account) {
        var _a;
        const actions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        const searchWordKey = key + (param.searchType || 'all');
        const savedSeq = actions.searchWord[searchWordKey];
        const srId = savedSeq || searchId || actions.searchSeq.next();
        if (!savedSeq) {
            this.storeSearchWords(srId, searchWordKey, _account);
        }
        const reqKey = this.buildSearchEntryReqKey(param);
        const searchMidsCacheElement = actions.searchMidsCache[srId];
        const resCacheElement = actions.searchResCache[srId];
        const savedFolderRes = resCacheElement && resCacheElement[reqKey];
        const mailStatEl = actions.searchStatCache[srId];
        const mailStat = mailStatEl && mailStatEl[reqKey];
        const hasCache = !!(searchMidsCacheElement && searchMidsCacheElement[reqKey] && savedFolderRes && mailStat);
        if (noData) {
            return hasCache;
        }
        return {
            hasCache,
            srId,
            reqKey,
            searchMidsCacheElement,
            savedFolderRes,
            mailStat,
        };
    }
    doGetSearchCacheInfo_sd(key, param, searchId, noData, _account) {
        var _a, _b;
        const actions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        const reqKey = this.buildSearchEntryReqKey(param);
        const reqKey_sd = `${key}_${param.subordinateId}_${(_b = param.subEmails) === null || _b === void 0 ? void 0 : _b.join('_')}_${param.searchType || 'all'}_${reqKey}`;
        const resCache_sd = actions.searchResCache_sd[reqKey_sd] || [];
        const hasCache = Array.isArray(resCache_sd) && !!resCache_sd.length;
        if (noData) {
            return hasCache;
        }
        return {
            hasCache,
            reqKey: reqKey_sd,
            resCache: resCache_sd,
        };
    }
    doGetSearchCacheInfoMoreAccounts(key, param, searchId, _account) {
        var _a, _b;
        const actions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        const reqKey = this.buildSearchEntryReqKey(param);
        const reqKey_more = `${key}_${(_b = param.subEmails) === null || _b === void 0 ? void 0 : _b.join('_')}_${param.searchType || 'all'}_${reqKey}`;
        const resCache_more = actions.searchResCacheMoreAccounts[reqKey_more] || [];
        const hasCache = Array.isArray(resCache_more) && !!resCache_more.length;
        return {
            hasCache,
            reqKey: reqKey_more,
            resCache: resCache_more,
        };
    }
    doClearSearchCache(_account) {
        var _a;
        console.log(4444, 'doClearSearchCache');
        const actions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        actions.searchWord = {};
        actions.searchMidsCache = {};
        actions.searchResCache = {};
        actions.searchStatCache = {};
        actions.localSearchIds = {};
        actions.searchResCacheMoreAccounts = {};
        this.storeApi.del(MailAbstractHandler.mailSearchSeq, { _account }).then();
        this.storeApi.del(MailAbstractHandler.mailSearchKeyWord, { _account }).then();
    }
    doClearSearchCache_sd(_account) {
        var _a;
        const actions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        actions.searchResCache_sd = {};
    }
    async doSearchMailIds(key, param, searchId) {
        if (!key) {
            return Promise.reject(new Error('请输入搜索词'));
        }
        const { _account } = param;
        const { hasCache, reqKey, searchMidsCacheElement } = this.doGetSearchCacheInfo(key, param, searchId, false, _account);
        if (hasCache) {
            return Promise.resolve(searchMidsCacheElement[reqKey] || []);
        }
        await this.doSearchMail(key, param, searchId);
        const nextRes = this.doGetSearchCacheInfo(key, param, searchId, false, _account);
        if (nextRes.hasCache) {
            return Promise.resolve(nextRes.searchMidsCacheElement[nextRes.reqKey] || []);
        }
        return [];
    }
    doSearchMailMoreAccounts(key, param, searchId) {
        if (!key) {
            return Promise.reject(new Error('请输入搜索词'));
        }
        const { _account, subEmails } = param;
        const { hasCache, reqKey, resCache } = this.doGetSearchCacheInfoMoreAccounts(key, param, searchId);
        param.addSentContent = true;
        const req = this.buildSearchEntryReq(key, param);
        req.summaryWindowSize = 0;
        req.windowSize = 3000;
        req.fid = req.fids;
        const start = param.index || 0;
        if (hasCache) {
            const result = resCache.slice(start, start + param.count);
            if (result && result.length > 0) {
                const promiseSummary = this.handleSummaryEntitiesMoreAccounts(result, key);
                const promiseEntry = this.handleListMailBoxEntities(req, { d: result, t: result.length }, Object.assign(Object.assign({}, param), { _account }), key).then(result => (Array.isArray(result) ? result : result.data));
                return Promise.all([promiseEntry, promiseSummary])
                    .then((res) => this.buildSearchResult([res[0], res[1], [], undefined], 0, key, resCache.length, param.id, param.searchType, param.filterCond, _account))
                    .catch(res => {
                    console.error('4444----聚合搜索--远程缓存命中失败', res);
                    return Promise.reject(this.commonCatch(res));
                });
            }
            return Promise.resolve(this.buildSearchResult([[], {}, [], {}], 0, '', 0, param.id, undefined, undefined, _account));
        }
        const key1 = 'getSearchMessagesMoreAccounts';
        const url = this.impl.buildUrl(this.systemApi.getUrl(key1), { subEmails });
        return this.impl
            .post(url, req, {
            url,
            data: req,
            cachePolicy: 'noCache',
            noEnqueue: true,
            contentType: 'json',
        })
            .then((res) => {
            var _a;
            const { data } = res;
            console.log('[doSearchMailMoreAccounts] return from network:', data);
            if (data === null || data === void 0 ? void 0 : data.success) {
                const emailInfosServer = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.emailInfos;
                const emailInfos = emailInfosServer.map(it => it);
                if (Array.isArray(emailInfos) && !!emailInfos.length) {
                    this.storeSearchCacheMoreAccounts(emailInfos, reqKey, _account);
                    const result = emailInfos.filter(it => typeof it !== 'string');
                    const nowResult = result.slice(start, start + param.count);
                    const promiseSummary = this.handleSummaryEntitiesMoreAccounts(nowResult, key);
                    const promiseEntry = this.handleListMailBoxEntities(req, { d: nowResult, t: nowResult.length }, Object.assign(Object.assign({}, param), { _account }), key).then(result => (Array.isArray(result) ? result : result.data));
                    return Promise.all([promiseEntry, promiseSummary])
                        .then((res) => this.buildSearchResult([res[0], res[1], [], undefined], 0, key, emailInfos.length, param.id, param.searchType, param.filterCond, _account))
                        .catch(res => {
                        console.error('服务端搜索错误：', res);
                        return Promise.reject(this.commonCatch(res));
                    });
                }
                return Promise.resolve(this.buildSearchResult([[], {}, [], {}], 0, '', 0, param.id, undefined, undefined, _account));
            }
            return Promise.reject(this.getErrMsg(data === null || data === void 0 ? void 0 : data.code));
        });
    }
    doSearchMoreAccounts(key, param, searchId) {
        console.log('doSearchMoreAccounts', key, param, searchId);
        if (!key) {
            return Promise.reject(new Error('请输入搜索词'));
        }
        const { _account, subEmails } = param;
        param.addSentContent = true;
        const req = this.buildSearchEntryReq(key, param);
        req.summaryWindowSize = 0;
        req.windowSize = 3000;
        req.fid = req.fids;
        const start = param.index || 0;
        const key1 = 'getSearchMessagesMoreAccounts';
        const url = this.impl.buildUrl(this.systemApi.getUrl(key1), { subEmails });
        return this.impl
            .post(url, req, {
            url,
            data: req,
            cachePolicy: 'noCache',
            noEnqueue: true,
            contentType: 'json',
        })
            .then((res) => {
            var _a;
            const { data } = res;
            console.log('[doSearchMailMoreAccounts] return from network:', data);
            if (data === null || data === void 0 ? void 0 : data.success) {
                const emailInfosServer = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.emailInfos;
                const emailInfos = emailInfosServer.map(it => it);
                if (Array.isArray(emailInfos) && !!emailInfos.length) {
                    const result = emailInfos.filter(it => typeof it !== 'string');
                    const nowResult = result.slice(start, start + param.count);
                    const promiseEntry = this.handleListMailBoxEntities(req, { d: nowResult, t: nowResult.length }, Object.assign(Object.assign({}, param), { _account }), key).then(result => (Array.isArray(result) ? result : result.data));
                    return Promise.all([promiseEntry])
                        .then((res) => res[0])
                        .catch(res => {
                        console.error('服务端搜索错误：', res);
                        return Promise.reject(this.commonCatch(res));
                    });
                }
                return Promise.resolve([]);
            }
            return Promise.reject(this.getErrMsg(data === null || data === void 0 ? void 0 : data.code));
        });
    }
    doSearchMail(key, param, searchId) {
        if (param.subEmails && param.subEmails.length > 0) {
            return this.doSearchMailMoreAccounts(key, param, searchId);
        }
        if (!key) {
            return Promise.reject(new Error('请输入搜索词'));
        }
        const { _account } = param;
        const { hasCache, srId, reqKey, searchMidsCacheElement, savedFolderRes, mailStat } = this.doGetSearchCacheInfo(key, param, searchId, false, _account);
        param.addSentContent = true;
        const req = this.buildSearchEntryReq(key, param);
        const start = param.index || 0;
        if (hasCache) {
            const allIds = searchMidsCacheElement[reqKey];
            const ids = allIds.slice(start, start + param.count);
            if (ids && ids.length > 0) {
                const promiseSummary = this.handleSummaryEntities(ids, key, _account);
                const promiseEntry = this.doListMailBoxEntities({
                    mids: ids,
                    count: ids.length,
                    _account,
                });
                return Promise.all([promiseEntry, promiseSummary])
                    .then((result) => {
                    const entries = Array.isArray(result[0]) ? result[0] : result[0].data;
                    const ccc = this.buildSearchResult([entries, result[1], savedFolderRes, mailStat], srId, key, allIds.length, param.id, param.searchType, param.filterCond, _account);
                    this.loggerApi.track('mail_search_cloud_cache_success', ccc);
                    return ccc;
                })
                    .catch(res => {
                    console.error('服务端缓存命中失败', res);
                    this.loggerApi.track('mail_search_cloud_cache_fail', {
                        res,
                        key,
                        param,
                    });
                    return Promise.reject(this.commonCatch(res));
                });
            }
            return Promise.resolve(this.buildSearchResult([[], {}, savedFolderRes, {}], srId, key, allIds.length, param.id, param.searchType, param.filterCond, _account));
        }
        const key1 = 'searchMail';
        const url = this.buildUrl(key1, undefined, undefined, _account);
        const oldFids = req.fids;
        if (req.fids && req.fids.length > 1) {
            req.fids = [req.fids[0]];
        }
        return this.impl
            .post(url, req, Object.assign(Object.assign({}, (this.getConfigForHttp(key1, {
            url,
            data: req,
            method: 'post',
        }) || {})), { _account }))
            .then((res) => {
            req.fids = oldFids;
            const data = res.data;
            console.log('[mail-search] return from network:', data);
            if (data.code === MailAbstractHandler.sOk) {
                const result = data.var.filter(it => typeof it !== 'string');
                const ids = data.var.map(it => (typeof it === 'string' ? it : it.id));
                this.storeSearchIds(srId, ids, reqKey, _account);
                const { groupings } = data;
                const promiseSummary = this.handleSummaryEntities(ids.slice(start, start + param.count), key, _account);
                const promiseEntry = this.handleListMailBoxEntities(req, { d: result, t: result.length }, Object.assign(Object.assign({}, param), { _account }), key).then(result => (Array.isArray(result) ? result : result.data));
                const filterGroupings = this.filterGrouping(groupings);
                const promiseFolder = this.handleSearchGroupResult(filterGroupings, _account);
                const promiseStat = this.handleStatResult(filterGroupings);
                return Promise.all([promiseEntry, promiseSummary, promiseFolder, promiseStat])
                    .then((res) => {
                    this.storeSearchFolderRes(res[2], reqKey, srId, _account);
                    this.storeSearchStat(res[3], reqKey, srId, _account);
                    this.saveMails(res[0], _account);
                    const bbb = this.buildSearchResult(res, srId, key, ids.length, param.id, param.searchType, param.filterCond, _account);
                    this.loggerApi.track('mail_search_cloud_server_success', bbb);
                    return bbb;
                })
                    .catch(res => {
                    console.error('服务端搜索错误：', res);
                    this.loggerApi.track('mail_search_cloud_server_fail', {
                        res,
                        key,
                        param,
                    });
                    return Promise.reject(this.commonCatch(res));
                });
            }
            return Promise.reject(this.getErrMsg(data.code));
        });
    }
    doSearchMail_sd(key, param, searchId) {
        if (!key) {
            return Promise.reject(new Error('请输入搜索词'));
        }
        const { _account, subordinateId, subEmails } = param;
        const { hasCache, reqKey, resCache } = this.doGetSearchCacheInfo_sd(key, param, searchId, false, _account);
        param.addSentContent = true;
        const req = this.buildSearchEntryReq(key, param);
        req.summaryWindowSize = 0;
        req.windowSize = 3000;
        req.fid = req.fids;
        const start = param.index || 0;
        if (hasCache) {
            const result = resCache.slice(start, start + param.count);
            if (result && result.length > 0) {
                const promiseSummary = this.handleSummaryEntities_sd(result, key, subordinateId);
                const promiseEntry = this.handleListMailBoxEntities(req, { d: result, t: result.length }, Object.assign(Object.assign({}, param), { _account }), key)
                    .then(result => (Array.isArray(result) ? result : result.data))
                    .then(result => result.map((m) => {
                    m.tpMailInfo = {
                        colleagueAccId: subordinateId,
                        belongEmail: m.owner,
                    };
                    m.isTpMail = true;
                    m.mailFrom = 'subordinate';
                    return m;
                }));
                return Promise.all([promiseEntry, promiseSummary])
                    .then((res) => this.buildSearchResult([res[0], res[1], [], undefined], 0, key, resCache.length, param.id, param.searchType, param.filterCond, _account))
                    .catch(res => {
                    console.error('4444----下属--远程缓存命中失败', res);
                    return Promise.reject(this.commonCatch(res));
                });
            }
            return Promise.resolve(this.buildSearchResult([[], {}, [], {}], 0, '', 0, param.id, undefined, undefined, _account));
        }
        const key1 = process.env.BUILD_ISEDM ? 'getColleagueSearchMessages' : 'getLxColleagueSearchMessages';
        const url = this.impl.buildUrl(this.systemApi.getUrl(key1), {
            colleagueAccId: subordinateId,
            subEmails,
        });
        return this.impl
            .post(url, req, {
            url,
            data: req,
            cachePolicy: 'noCache',
            noEnqueue: true,
            contentType: 'json',
        })
            .then((res) => {
            var _a;
            const { data } = res;
            console.log('[mail-search-sd] return from network:', data);
            if (data === null || data === void 0 ? void 0 : data.success) {
                const emailInfosServer = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.emailInfos;
                const emailInfos = emailInfosServer.map(it => {
                    it.owner = it.belongEmail;
                    return it;
                });
                if (Array.isArray(emailInfos) && !!emailInfos.length) {
                    this.storeSearchCache_sd(emailInfos, reqKey, _account);
                    const result = emailInfos.filter(it => typeof it !== 'string');
                    const nowResult = result.slice(start, start + param.count);
                    const promiseSummary = this.handleSummaryEntities_sd(nowResult, key, subordinateId);
                    const promiseEntry = this.handleListMailBoxEntities(req, { d: nowResult, t: nowResult.length }, Object.assign(Object.assign({}, param), { _account }), key)
                        .then(result => (Array.isArray(result) ? result : result.data))
                        .then(result => result.map((m) => {
                        m.tpMailInfo = {
                            colleagueAccId: subordinateId,
                            belongEmail: m.owner,
                        };
                        m.isTpMail = true;
                        m.mailFrom = 'subordinate';
                        return m;
                    }));
                    return Promise.all([promiseEntry, promiseSummary])
                        .then((res) => this.buildSearchResult([res[0], res[1], [], undefined], 0, key, emailInfos.length, param.id, param.searchType, param.filterCond, _account))
                        .catch(res => {
                        console.error('服务端搜索错误：', res);
                        return Promise.reject(this.commonCatch(res));
                    });
                }
                return Promise.resolve(this.buildSearchResult([[], {}, [], {}], 0, '', 0, param.id, undefined, undefined, _account));
            }
            return Promise.reject(this.getErrMsg(data === null || data === void 0 ? void 0 : data.code));
        });
    }
    saveMails(MailEntryModels, _account) {
        const allMails = MailEntryModels;
        if (allMails && allMails.length) {
            const selfMails = allMails.filter(mail => !mail.isTpMail);
            const tpMails = allMails.filter(mail => !!mail.isTpMail);
            if (selfMails.length > 0) {
                this.mailDbHandler.saveMails(selfMails, 'default', _account).catch();
            }
            if (tpMails.length > 0) {
                this.mailDbHandler.saveTpMails(tpMails).catch();
            }
        }
    }
    doSpecialJob(key) {
        var _a, _b, _c;
        console.info('entered once hello ------------------------------------!!');
        if (key === '*#build*#') {
            this.eventApi.sendSysEvent({
                eventName: 'error',
                eventLevel: 'error',
                eventStrData: '',
                eventData: {
                    popupType: 'window',
                    popupLevel: 'info',
                    title: '构建信息',
                    content: window.BuildData,
                    code: 'PARAM.ERR',
                },
                eventSeq: 0,
            });
        }
        else if (key === '*#shiftHost*#') {
            this.eventApi.sendSysEvent({
                eventName: 'error',
                eventLevel: 'error',
                eventStrData: '',
                eventData: {
                    popupType: 'window',
                    popupLevel: 'info',
                    title: '切换到nginx转发',
                    content: '此模式不影响mail(hz).qiye.163.com 的host转发配置',
                    code: 'PARAM.ERR',
                },
                eventSeq: 0,
            });
            customerSysConfig.shiftHost = 'true';
        }
        else if (key === '*#devtools*#') {
            if (this.systemApi.isElectron()) {
                window.electronLib.windowManage.toggleDevTools();
            }
        }
        else if (key === '*#raiseException*#') {
            this.eventApi.sendSysEvent({
                eventName: 'error',
                eventLevel: 'error',
                eventStrData: '',
                eventData: {
                    popupType: 'toast',
                    popupLevel: 'info',
                    title: '自动产生错误',
                    code: 'PARAM.ERR',
                },
                eventSeq: 0,
            });
            this.errReporter.doReportMessage(new Error('error on purpose' + Math.random()));
            throw new Error('error on purpose');
        }
        else if (key === '*#popClose*#') {
            MailContentHandler.debugMailPopWindow = false;
            this.eventApi.sendSysEvent({
                eventName: 'error',
                eventLevel: 'error',
                eventStrData: '',
                eventData: {
                    popupType: 'toast',
                    popupLevel: 'info',
                    title: '关闭弹窗调试',
                    code: 'PARAM.ERR',
                },
                eventSeq: 0,
            });
        }
        else if (key === '*#popOpen*#') {
            MailContentHandler.debugMailPopWindow = true;
            this.eventApi.sendSysEvent({
                eventName: 'error',
                eventLevel: 'error',
                eventStrData: '',
                eventData: {
                    popupType: 'toast',
                    popupLevel: 'info',
                    title: '开启弹窗调试',
                    code: 'PARAM.ERR',
                },
                eventSeq: 0,
            });
        }
        else if (key === '*#mailCacheEnable*#') {
            this.setDbEnable(true);
            this.eventApi.sendSysEvent({
                eventName: 'error',
                eventLevel: 'error',
                eventStrData: '',
                eventData: {
                    popupType: 'toast',
                    popupLevel: 'info',
                    title: '开启邮件本地存储',
                    code: 'PARAM.ERR',
                },
                eventSeq: 0,
            });
        }
        else if (key === '*#mailCacheDisable*#') {
            this.setDbEnable(false);
            this.eventApi.sendSysEvent({
                eventName: 'error',
                eventLevel: 'error',
                eventStrData: '',
                eventData: {
                    popupType: 'toast',
                    popupLevel: 'info',
                    title: '关闭邮件本地存储',
                    code: 'PARAM.ERR',
                },
                eventSeq: 0,
            });
        }
        else if (key === '*#net*#') {
            if (typeof window.electronLib !== 'undefined' && window.electronLib.appManage) {
                const path = (config('host') || '');
                const host = new URL(path).hostname;
                window.electronLib.appManage.getNetState(host).then((res) => {
                    const post = {
                        host,
                        electron_online: navigator.onLine,
                        dns_lookup_v4: res[0],
                        dns_lookup_v6: res[1],
                        dns_resolveAny: res[2],
                        traceroute: res[3],
                    };
                    this.eventApi.sendSysEvent({
                        eventName: 'error',
                        eventLevel: 'error',
                        eventStrData: '',
                        eventData: {
                            popupType: 'window',
                            popupLevel: 'info',
                            title: '网络监测',
                            content: JSON.stringify(post),
                            code: 'PARAM.ERR',
                        },
                        eventSeq: 0,
                    });
                });
            }
        }
        else if (key === '*#cleanDb*#') {
            this.eventApi.sendSysEvent({
                eventName: 'error',
                eventLevel: 'error',
                eventStrData: '',
                eventData: {
                    popupType: 'toast',
                    popupLevel: 'info',
                    title: '清理数据库',
                    code: 'PARAM.ERR',
                },
                eventSeq: 0,
            });
            if (this.systemApi.isElectron() && window.electronLib) {
                window.electronLib.windowManage.clearLocalData('indexdb').then(() => {
                    this.eventApi.sendSysEvent({
                        eventName: 'error',
                        eventLevel: 'error',
                        eventStrData: '',
                        eventData: {
                            popupType: 'toast',
                            popupLevel: 'info',
                            title: '清理数据库成功',
                            code: 'PARAM.ERR',
                        },
                        eventSeq: 0,
                    });
                });
                window.electronLib.windowManage.clearLocalData('localstorage').then(() => {
                    this.eventApi.sendSysEvent({
                        eventName: 'error',
                        eventLevel: 'error',
                        eventStrData: '',
                        eventData: {
                            popupType: 'toast',
                            popupLevel: 'info',
                            title: '清理本地数据完成',
                            code: 'PARAM.ERR',
                        },
                        eventSeq: 0,
                    });
                });
                this.eventApi.sendSimpleSysEvent('logout');
            }
        }
        else if (key === '*#settings*#') {
            if (this.systemApi.isElectron() && window.electronLib) {
                window.electronLib.windowManage
                    .createWindow({
                    type: 'customer',
                    url: 'https://mailhz.qiye.163.com/js6/main.jsp?sid=' + ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.sessionId) + '&hl=zh_CN#module=options.BaseSetModule%7C%7B%7D',
                    setMainWindowCookie: true,
                })
                    .then((win) => {
                    window.electronLib.windowManage.show(win.winId);
                });
            }
        }
        else if (key === '*#schedulePort*#') {
            if (this.systemApi.isElectron() && window.electronLib) {
                window.electronLib.windowManage
                    .createWindow({
                    type: 'customer',
                    url: 'https://mailhz.qiye.163.com/static/schedulemanager/index.html?sid=' +
                        ((_b = this.systemApi.getCurrentUser()) === null || _b === void 0 ? void 0 : _b.sessionId) +
                        '&hl=zh_CN&ver=js6#/lingxi/calender/port',
                    setMainWindowCookie: true,
                })
                    .then((win) => {
                    window.electronLib.windowManage.show(win.winId);
                });
            }
        }
        else if (key === '*#scheduleNew*#') {
            if (this.systemApi.isElectron() && window.electronLib) {
                window.electronLib.windowManage
                    .createWindow({
                    type: 'customer',
                    url: 'https://mailhz.qiye.163.com/static/schedulemanager/index.html?sid=' +
                        ((_c = this.systemApi.getCurrentUser()) === null || _c === void 0 ? void 0 : _c.sessionId) +
                        '&hl=zh_CN&ver=js6#/lingxicalender/create',
                    setMainWindowCookie: true,
                })
                    .then((win) => {
                    window.electronLib.windowManage.show(win.winId);
                });
            }
        }
        else if (key === '*#disableInterval*#') {
            this.eventApi.sendSysEvent({
                eventName: 'error',
                eventLevel: 'error',
                eventStrData: '',
                eventData: {
                    popupType: 'toast',
                    popupLevel: 'info',
                    title: '关闭定时事件',
                    code: 'PARAM.ERR',
                },
                eventSeq: 0,
            });
            this.systemApi.cancelEvent('long', '', true);
        }
        else if (key === '*#enableInterval*#') {
            this.eventApi.sendSysEvent({
                eventName: 'error',
                eventLevel: 'error',
                eventStrData: '',
                eventData: {
                    popupType: 'toast',
                    popupLevel: 'info',
                    title: '关闭定时事件',
                    code: 'PARAM.ERR',
                },
                eventSeq: 0,
            });
            this.systemApi.cancelEvent('long', '', false);
        }
        else if (key.startsWith('*#logToken:') && key.endsWith('*#')) {
            const appKey = key.replace('*#logToken:', '').replace('*#', '');
            this.dataTrakerApi.setToken(appKey);
            this.eventApi.sendSysEvent({
                eventName: 'error',
                eventLevel: 'error',
                eventStrData: '',
                eventData: {
                    popupType: 'toast',
                    popupLevel: 'info',
                    title: '设置token 成功',
                    code: 'PARAM.ERR',
                },
                eventSeq: 0,
            });
            this.eventApi.sendSysEvent({
                eventName: 'setDATrackerToken',
                eventData: {
                    token: appKey,
                },
            });
            this.systemApi.cancelEvent('long', '', false);
        }
        else if (key === '*#trafficLabel*#') {
            this.eventApi.sendSysEvent({
                eventName: 'changeLxTrafficLabel',
                eventSeq: 0,
            });
        }
    }
    buildSearchEntryReqKey(req) {
        var _a;
        let ret = `${req.status || ''}_${((_a = req.ids) === null || _a === void 0 ? void 0 : _a.join(',')) || ''}_${req.id || ''}`;
        if (req === null || req === void 0 ? void 0 : req.filterCond) {
            const filterCond = req === null || req === void 0 ? void 0 : req.filterCond;
            const fromFilterCond = filterCond.find(f => f && f.field === 'from');
            const sentDateFilterCond = filterCond.find(f => f && f.field === 'sentDate');
            const attachedFilterCond = filterCond.find(f => f && f.field === 'flags' && f.operand && f.operand.attached !== undefined);
            const readFilterCond = filterCond.find(f => f && f.field === 'flags' && f.operand && f.operand.read !== undefined);
            const attachedOperand = attachedFilterCond ? JSON.stringify(attachedFilterCond.operand) : '';
            const readOperand = readFilterCond ? JSON.stringify(readFilterCond.operand) : '';
            if (fromFilterCond) {
                ret = `${ret}_${fromFilterCond.field || ''}_${(fromFilterCond === null || fromFilterCond === void 0 ? void 0 : fromFilterCond.operator) || ''}_${fromFilterCond.operand || ''}`;
            }
            if (sentDateFilterCond) {
                ret = `${ret}_${sentDateFilterCond.field || ''}_${(sentDateFilterCond === null || sentDateFilterCond === void 0 ? void 0 : sentDateFilterCond.operator) || ''}_${sentDateFilterCond.operand || ''}`;
            }
            if (attachedFilterCond) {
                ret = `${ret}_${attachedFilterCond.field || ''}_${(attachedFilterCond === null || attachedFilterCond === void 0 ? void 0 : attachedFilterCond.operator) || ''}_${attachedOperand || ''}`;
            }
            if (readFilterCond) {
                ret = `${ret}_${readFilterCond.field || ''}_${(readFilterCond === null || readFilterCond === void 0 ? void 0 : readFilterCond.operator) || ''}_${readOperand || ''}`;
            }
        }
        return ret;
    }
    buildSearchEntryReq(key, param) {
        let ftsFiles = MailAbstractHandler.searchFields;
        if (param.searchType === 'title') {
            ftsFiles = 'subj';
        }
        else if (param.searchType === 'sender') {
            ftsFiles = 'from';
        }
        else if (param.searchType === 'receiver') {
            ftsFiles = 'to';
        }
        else if (param.searchType === 'attachment') {
            ftsFiles = 'aname';
        }
        else if (param.searchType === 'receiverAndSender') {
            ftsFiles = 'from,to';
        }
        const cond = Array.isArray(param.filterCond) ? param.filterCond : param.filterCond ? [param.filterCond] : [];
        const target = {
            'fts.ext': true,
            'fts.fields': ftsFiles,
            conditions: cond,
            groupings: {
                fid: '',
                'flags.read': '',
                sentDate: '',
                'flags.attached': '',
                fromAddress: '',
            },
            order: 'date',
            operator: 'and',
            desc: true,
            start: param.index || 0,
            windowSize: param.count,
            pattern: key,
            summaryWindowSize: param.count,
            returnAttachments: true,
            returnTotal: true,
            returnTag: true,
            tag: param.tag,
        };
        let fids = [];
        if (param.ids && param.ids.length > 0) {
            fids = param.ids.filter(it => it > 0);
        }
        else if (param.id && param.id > 0) {
            fids = [param.id];
        }
        target.fids = fids;
        if (param.status) {
            switch (param.status) {
                case 'spam':
                    break;
                case 'redFlag':
                    target.conditions.push({
                        field: 'label0',
                        operator: '=',
                        operand: 1,
                    });
                    break;
                case 'read':
                    target.conditions.push({
                        field: 'flags',
                        operator: '=',
                        operand: { read: true },
                    });
                    break;
                case 'unread':
                    target.conditions.push({
                        field: 'flags',
                        operator: '=',
                        operand: { read: false },
                    });
                    break;
                default:
                    break;
            }
        }
        return target;
    }
    handleStatResult(gp) {
        const ret = {};
        const groupings = gp && Object.keys(gp).length ? gp : {};
        Object.keys(groupings).forEach((it) => {
            const item = {
                items: {},
                name: '',
            };
            const confItem = this.statKeyMap[it];
            if (confItem) {
                item.name = confItem.label;
                const result = groupings[it];
                result === null || result === void 0 ? void 0 : result.forEach(gpItem => {
                    const key = it === 'sentDate' ? moment(gpItem.val).format('YYYY-MM-DD') : String(gpItem.val);
                    const val = confItem.valueMapping(key);
                    if (val) {
                        item.items[key] = {
                            label: it === 'fromAddress' ? gpItem.nickName || val.valueLabel : val.valueLabel,
                            key,
                            value: gpItem.cnt,
                            filterCond: val.cond,
                        };
                        if (it === 'fromAddress') {
                            item.items[key] = Object.assign(Object.assign({}, item.items[key]), { contactLabel: gpItem.contactLabel });
                        }
                    }
                });
                if (it === 'sentDate') {
                    item.items = this.asignSentDateByLabel(item.items);
                }
                if (it === 'fromAddress') {
                    item.items = this.handleKeyFromAddress(item.items);
                }
                ret[it] = item;
            }
        });
        return Promise.resolve(ret);
    }
    asignSentDateByLabel(obj) {
        const labelObj = {};
        const resultObj = {};
        if (isObject(obj)) {
            Object.values(obj).forEach(k => {
                const label = k.label;
                if (labelObj[label]) {
                    const oldKey = +moment(labelObj[label].key);
                    const newKey = +moment(k.key);
                    labelObj[label] = Object.assign(Object.assign({}, labelObj[label]), { value: oldKey > newKey ? k.value : labelObj[label].value, key: oldKey > newKey ? k.key : labelObj[label].key, filterCond: oldKey > newKey ? k.filterCond : labelObj[label].filterCond });
                }
                else {
                    labelObj[label] = Object.assign({}, k);
                }
            });
            Object.values(labelObj).forEach(k => {
                resultObj[k.key] = k;
            });
            return resultObj;
        }
        return obj;
    }
    handleKeyFromAddress(obj) {
        if (isObject(obj)) {
            const resultObj = {};
            Object.values(obj).forEach(k => {
                const key = k.filterCond.operand;
                if (resultObj[key]) {
                    resultObj[key] = Object.assign(Object.assign(Object.assign({}, resultObj[key]), k), { key, value: resultObj[key].value + k.value });
                }
                else {
                    resultObj[key] = Object.assign(Object.assign({}, k), { key });
                }
            });
            return resultObj;
        }
        return obj;
    }
    filterGrouping(gp) {
        var _a;
        if (!gp || Object.keys(gp).length === 0) {
            return gp;
        }
        const groupings = Object.assign({}, gp);
        if (groupings.sentDate && groupings.sentDate.length) {
            const len = groupings.sentDate.length;
            let sentDateValue = 0;
            groupings.sentDate = (_a = groupings.sentDate) === null || _a === void 0 ? void 0 : _a.map((c, idx) => {
                if (idx < len - 1) {
                    sentDateValue += c.cnt;
                    c.cnt = sentDateValue;
                }
                return c;
            });
        }
        return groupings;
    }
    storeSearchStat(re, reqKey, srId, _account) {
        var _a;
        console.log('store search result ', reqKey, re, srId);
        const targetActions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (!targetActions)
            return;
        targetActions.searchStatCache[srId] = targetActions.searchStatCache[srId] || {};
        targetActions.searchStatCache[srId][reqKey] = re;
    }
    storeLocalSearchIds(mids, checkMids, key, _account) {
        var _a;
        console.log('storeLocalSearchIds:', mids, checkMids, key, _account);
        const targetActions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (!targetActions)
            return;
        targetActions.localSearchIds = {};
        targetActions.localSearchIds[key] = [mids, checkMids];
    }
    buildLocalSearchCacheKey(key, param) {
        const { _account, searchType, checkType } = param || {};
        const result = `${key}_${_account || ''}_${searchType || 'all'}_${checkType || ''}`;
        return result;
    }
    doGetLocalSearchCacheIds(key, param) {
        var _a;
        const localSearchCacheKey = this.buildLocalSearchCacheKey(key, param);
        const result = {
            hasCache: false,
            mids: new Set(),
            checkMids: new Set(),
            cacheKey: localSearchCacheKey,
        };
        const targetActions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account: param._account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (targetActions.localSearchIds && targetActions.localSearchIds[localSearchCacheKey]) {
            const localSearchCache = targetActions.localSearchIds[localSearchCacheKey];
            if (Array.isArray(localSearchCache) && localSearchCache.length === 2) {
                result.hasCache = true;
                result.mids = localSearchCache[0] || new Set();
                result.checkMids = localSearchCache[1] || new Set();
            }
        }
        return result;
    }
}
